import React from "react";
import Link from "gatsby-link";
// import ClassNames from 'classnames'

class TestimonialItem extends React.Component {
  constructor(props) {
    super(props);
    this.textContent = this.textContent.bind(this);
    this.renderContents = this.renderContents.bind(this);
  }

  textContent(c) {
    return {
      __html: c
    };
  }

  renderContents(item, type) {
    return (
      <div>
        {type === "image" && (
          <div className="content">
            <img src={item.image.url + '?w=609&h=609'} />
          </div>
        )}
        <div className="header">
          <div
            className="avatar"
            style={{ backgroundImage: `url(${item.avatar.url + '?w=50&h=50'})` }}
          />
          <div className="info">
            <span className="name">{item.name}</span>
            <span className="username">{item.username}</span>
          </div>
          {type === "text" && (
            <div className="icon">
              <img src="/images/testimonials/facebook-icon.svg" />
            </div>
          )}
        </div>
        {type === "text" && (
          <div className="content" dangerouslySetInnerHTML={this.textContent(item.text)} />
        )}
      </div>
    );
  }

  render() {
    let item = this.props.data.node;
    let type = "image";
    if (item.image === null) {
      type = "text";
    }

    if (item.linksTo === "") {
      return (
        <div className={`item ${type}`}>{this.renderContents(item, type)}</div>
      );
    } else {
      return (
        <a className={`item ${type}`} href={item.linksTo} target="_blank">
          {this.renderContents(item, type)}
        </a>
      );
    }

    switch (type) {
      case "text":
        return (
          <div className="item text">
            <div />
          </div>
        );
        break;
      case "image":
        return (
          <div className="item image">
            <div>
              <div className="header">
                <div
                  className="avatar"
                  style={{ backgroundImage: `url(${item.avatar.url})` }}
                />
                <div className="info">
                  <span className="name">{item.name}</span>
                  <span className="username">{item.username}</span>
                </div>
                <div className="icon" />
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  }
}

export default TestimonialItem;



// WEBPACK FOOTER //
// ./src/home/testimonial-item.js